import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FinanceFormStandalone from "./FinanceFormStandalone";
import { fetchFinanceEditForm } from "../../../modules/api";
import { updatePageTitle } from "../../../modules/legacyUtils";
import { referrerPathname } from "../../../modules/utils";
import { trackEvent } from "../../../modules/tracking";
import { AnalyticsEvents } from "../../../modules/analyticsEvents";
export default function FinanceEditPage({ onSaved }) {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate(); // Unlike the other Phase 1 SPA resources, this page's entry and exit points
    // are frequently OUTSIDE the SPA's own client-side route table (e.g.
    // users#show, dashboard#review) - so a client-side navigate() would just
    // change the URL bar without rendering anything for those paths. Use a hard
    // redirect instead, mirroring what the old server-side referrer-based
    // redirect always did (a real browser navigation).
    const returnPath = location.state?.prevPathname || referrerPathname() || '/my_rift/dashboard';
    const [financeData, setFinanceData] = useState(null);
    const [isCIS, setIsCIS] = useState(false);
    useEffect(() => { updatePageTitle('About your finances'); trackEvent(AnalyticsEvents.screenViews.financeForm()); }, []);
    useEffect(() => { let cancelled = false; fetchFinanceEditForm(id).then(data => { if (cancelled)
        return; setFinanceData({ finance: data.resource, income_options: data.income_options }); setIsCIS(data.isCis); }); return () => { cancelled = true; }; }, [id]);
    return /*#__PURE__*/ React.createElement(FinanceFormStandalone, { key: financeData?.finance?.id, financeData: financeData, isCIS: isCIS, referrer: returnPath, onCancel: () => navigate(returnPath), onAfterSubmit: () => { if (onSaved)
            onSaved(); navigate(returnPath); } });
}
